module.exports = __webpack_public_path__ + "static/people_pop31-e9e7d704002b2aee293f82b6b3b39c0e.png";